(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
  });

  initProductAccordion();
  initZoomImage();
})();

(() => {
  const sectionId = '{{ section.id }}';
  const container = document.querySelector(`#FrequencyMetafield-${sectionId}`);
  const jsonEl = document.querySelector(`#FrequencyMetafieldsJson-${sectionId}`);

  if (!container || !jsonEl) return;

  let metafieldsByVariant = {};

  try {
    metafieldsByVariant = JSON.parse(jsonEl.textContent);
  } catch (error) {
    console.warn('Invalid frequency metafield JSON', error);
    return;
  }

  const allowedFrequencies = new Set([
    '1 Month Subscription',
    '3 Month Subscription',
    '6 Month Subscription'
  ]);

  function getCurrentVariantId() {
    const input = document.querySelector(`form[action*="/cart/add"] input[name="id"]`);
    return input?.value;
  }

  function renderFrequencyMetafield() {
    const variantId = getCurrentVariantId();
    const data = metafieldsByVariant[variantId];

    if (!data || !allowedFrequencies.has(data.frequency) || !data.content) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }

    container.innerHTML = data.content;
    container.hidden = false;
  }

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('input[type="radio"][name^="options["]') ||
      event.target.matches('select[name^="options["]')
    ) {
      setTimeout(renderFrequencyMetafield, 0);
    }
  });

  renderFrequencyMetafield();
})();
